/**
 * @description Imports all authentication Promises
 */
import { login, logout } from './auth.api'

/**
 * @description Imports all clubs Promises
 */
import { getClubs, createClub, deleteClub } from './clubs.api'

/**
 * @description Imports all user Promises
 */
import { getUser } from './user.api'

/**
 * @description Export all authentication Promises
 */
export const auth = {
  login,
  logout
}

/**
 * @description Export all clubs Promises
 */
export const clubs = {
  getClubs,
  createClub,
  deleteClub
}

/**
 * @description Export all user Promises
 */
export const user = {
  getUser
}
